const newArea = {
  snackbar: "Your update is ready",
  name: "Company Name",
  save: "Save",
  cancel: "Cancel",
  area: "Company",
  formTitle: "New Company",
  confirm: "Are you sure you want to delete this item?",
  close: "Close",
  delete: "Delete"
};
export default newArea;
